import { render, staticRenderFns } from "./Physiotherapists.vue?vue&type=template&id=a7da8228&scoped=true"
import script from "./Physiotherapists.vue?vue&type=script&lang=ts"
export * from "./Physiotherapists.vue?vue&type=script&lang=ts"
import style0 from "./Physiotherapists.vue?vue&type=style&index=0&id=a7da8228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7da8228",
  null
  
)

export default component.exports